/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/RequirementCreationView/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import { IconButton } from "@mui/material";
import { ReactComponent as ChevronLeftIcon } from "../../assets/icons/UserViews/ChevronLeftIcon.svg";
import styles from "./index.module.css";
import { useRequirementCreationForm } from "./useRequirementCreationForm.js";
import RequirementCreationFields from "./RequirementCreationFields.jsx";

const RequirementCreationView = ({
  categories,
  sectors,
  originalCertifications,
  onCreateRequirement,
  onBack,
}) => {
  const form = useRequirementCreationForm({ onCreateRequirement, onBack });

  return (
    <div className={styles.container}>
      <div className={styles.backNavigation}>
        <IconButton onClick={onBack}>
          <ChevronLeftIcon />
        </IconButton>
        <label className={styles.title}>
          {form.t("components.requirementCreationModal.header")}
        </label>
      </div>
      <RequirementCreationFields
        categories={categories}
        sectors={sectors}
        originalCertifications={originalCertifications}
        onBack={onBack}
        form={form}
      />
    </div>
  );
};

export default RequirementCreationView;
